"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigSet = void 0;
/**
 * BigSet implementation allows callers to handle more than 2^24 items in memory.
 * - This is not directly compatible with existing JS Set, but fulfills most of the API.
 * - Why? it should not be an encouraged pattern to operate on this size of data in memory
 * - If this is being used, it must be intentional
 */
class BigSet {
    // Internal limit is used to determine when to create a new internal set
    individualSetSizelimit = 10_000_000;
    // Internal data storage with chunked sets, not to be exposed directly
    // Always initialized with one empty set
    sets = [new Set()];
    /**
     * BigSet implementation allows callers to handle more than 2^24 items in memory.
     * - This is not directly compatible with existing JS Set, but fulfills most of the API.
     * - Why? it should not be an encouraged pattern to operate on this size of data in memory
     * - If this is being used, it must be intentional
     *
     * BigSet constructor accepts entries and an internal set size limit override
     * @param entries Initial set of data to populate
     * @param individualSetSizelimit Internal set size override, but always capped at 10 million
     *
     */
    constructor(entries = [], individualSetSizelimit = 10_000_000) {
        this.individualSetSizelimit = individualSetSizelimit;
        for (const key of entries) {
            this.add(key);
        }
    }
    // Mutable attribute, implement as getter
    get size() {
        // This should be O(1) operation as long as individual sets provide the same access pattern
        return this.sets.reduce((sum, set) => sum + set.size, 0);
    }
    // Operations
    // No chaining enabled
    add(key) {
        // *** 3 processing scenarios, in order of priority ***
        // 1) Skip if key was already added
        if (this.has(key)) {
            return;
        }
        // 2) Add to set with capacity
        const setWithCapacity = this.sets.find((set) => set.size < this.individualSetSizelimit);
        if (setWithCapacity) {
            setWithCapacity.add(key);
            return;
        }
        // 3) No set contains the key, or has capacity -> add a new set
        this.sets.push(new Set([key]));
    }
    has(key) {
        return this.sets.some((set) => set.has(key));
    }
    // Iterators - supporting only the expected access pattern to retrieve members of set
    keys() {
        function* generator(sets) {
            for (const set of sets) {
                yield* set.keys();
            }
        }
        return generator(this.sets);
    }
    // Iterator is necessary to perform operations like Array.from(BigSet)
    [Symbol.iterator]() {
        return this.keys();
    }
}
exports.BigSet = BigSet;
//# sourceMappingURL=bigSet.js.map